package de.oevbs.kunde.kundenportal2.services.contract

import de.oevbs.kunde.kundenportal2.components.contentContainer
import dev.fritz2.core.RenderContext

fun RenderContext.contractsStart() {
    val contractStore = ContractStore(job)
    contentContainer {
        contractStore.mode.render { mode ->
            when (mode) {
                is ContractStore.Mode.List -> initAndRenderContractList(contractStore)
                is ContractStore.Mode.Details -> initAndRenderDetails(mode.contractNumber, contractStore)
            }
        }
    }
}
